import React, { useState } from "react";

import Hdg from "./components/Hdg";

import SubmitForm from "./SubmitForm";
import Submitted from "./Submitted";

const App = () => {
	const [status, setStatus] = useState(0); // 0 = form, 1 = submitted

	return (
		<div id="full-column">
			<Hdg />
			{status === 1 ? <Submitted /> : <SubmitForm setStatus={setStatus} />}
		</div>
	);
};

export default App;
